import React from 'react';

const SHORTCUT_GROUPS = [
  {
    group: 'Navegacion entre pantallas',
    shortcuts: [
      { keys: ['Alt', '1'], action: 'Ir al Dashboard principal' },
      { keys: ['Alt', '2'], action: 'Ir a la Calculadora de lotes' },
      { keys: ['Alt', '3'], action: 'Ir a Gestion de lotes activos' },
      { keys: ['Alt', '4'], action: 'Ir a Inventario' },
      { keys: ['Alt', '5'], action: 'Ir a Analisis de ventas' },
      { keys: ['Alt', 'M'], action: 'Ir a Datos de Mercado' },
      { keys: ['Alt', 'S'], action: 'Ir a Configuracion' },
      { keys: ['Alt', 'H'], action: 'Abrir esta pantalla de Ayuda' },
    ],
  },
  {
    group: 'Calculadora y datos',
    shortcuts: [
      { keys: ['Alt', 'N'], action: 'Nuevo lote en la Calculadora' },
      { keys: ['Alt', 'R'], action: 'Refrescar datos de mercado' },
      { keys: ['Ctrl', 'S'], action: 'Guardar formulario actual' },
      { keys: ['Ctrl', 'Enter'], action: 'Confirmar / Enviar formulario' },
      { keys: ['Escape'], action: 'Cerrar modal o cancelar accion' },
    ],
  },
  {
    group: 'Interfaz',
    shortcuts: [
      { keys: ['Alt', 'T'], action: 'Alternar tema claro / oscuro' },
      { keys: ['Alt', 'P'], action: 'Abrir Preferencias de usuario' },
      { keys: ['?'], action: 'Mostrar esta guia de atajos' },
      { keys: ['Ctrl', '/'], action: 'Enfocar barra de busqueda (si disponible)' },
    ],
  },
];

function Kbd({ children }) {
  return (
    <kbd
      className="inline-flex items-center justify-center px-2 py-0.5 rounded border font-medium"
      style={{
        fontFamily: '"IBM Plex Mono", monospace',
        fontSize: '0.75rem',
        background: 'var(--color-muted)',
        borderColor: 'var(--color-border)',
        color: 'var(--color-foreground)',
        boxShadow: '0 1px 0 var(--color-border)',
        minWidth: 28,
      }}
    >
      {children}
    </kbd>
  );
}

export default function KeyboardShortcutsTab() {
  return (
    <div className="space-y-8">
      <p className="text-muted-foreground" style={{ fontSize: '0.9rem', fontFamily: '"IBM Plex Sans", sans-serif', lineHeight: 1.6 }}>
        Atajos de teclado para usuarios avanzados. Aumentan la velocidad de trabajo sin usar el raton.
      </p>
      {SHORTCUT_GROUPS?.map((group) => (
        <div key={group?.group}>
          <h3 className="font-semibold text-foreground mb-3" style={{ fontSize: '0.9375rem', fontFamily: 'var(--font-heading)', letterSpacing: '-0.01em' }}>
            {group?.group}
          </h3>
          <div className="rounded-lg border overflow-hidden" style={{ borderColor: 'var(--color-border)', background: 'var(--color-card)' }}>
            <table className="w-full">
              <thead>
                <tr style={{ borderBottom: '1px solid var(--color-border)', background: 'var(--color-muted)' }}>
                  <th className="px-5 py-2.5 text-left" style={{ fontSize: '0.75rem', fontFamily: '"IBM Plex Sans", sans-serif', color: 'var(--color-muted-foreground)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', width: '40%' }}>
                    Atajo
                  </th>
                  <th className="px-5 py-2.5 text-left" style={{ fontSize: '0.75rem', fontFamily: '"IBM Plex Sans", sans-serif', color: 'var(--color-muted-foreground)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    Accion
                  </th>
                </tr>
              </thead>
              <tbody>
                {group?.shortcuts?.map((s, i) => (
                  <tr key={i} style={{ borderBottom: i < group?.shortcuts?.length - 1 ? '1px solid var(--color-border)' : 'none' }}>
                    <td className="px-5 py-3">
                      <div className="flex items-center gap-1.5 flex-wrap">
                        {s?.keys?.map((k, ki) => (
                          <React.Fragment key={ki}>
                            <Kbd>{k}</Kbd>
                            {ki < s?.keys?.length - 1 && (
                              <span style={{ color: 'var(--color-muted-foreground)', fontSize: '0.75rem', fontFamily: '"IBM Plex Sans", sans-serif' }}>+</span>
                            )}
                          </React.Fragment>
                        ))}
                      </div>
                    </td>
                    <td className="px-5 py-3" style={{ fontSize: '0.875rem', fontFamily: '"IBM Plex Sans", sans-serif', color: 'var(--color-foreground)' }}>
                      {s?.action}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
      <div
        className="rounded-lg p-4 flex items-start gap-3"
        style={{ background: 'color-mix(in srgb, var(--color-accent) 8%, var(--color-muted))', border: '1px solid color-mix(in srgb, var(--color-accent) 20%, transparent)' }}
      >
        <span style={{ fontSize: '1.1rem' }}>{'\u{1F4A1}'}</span>
        <p style={{ fontSize: '0.875rem', fontFamily: '"IBM Plex Sans", sans-serif', color: 'var(--color-muted-foreground)', lineHeight: 1.6 }}>
          Los atajos de navegacion (Alt + numero) funcionan desde cualquier pantalla de la aplicacion.
          En Mac, usa Option en lugar de Alt.
        </p>
      </div>
    </div>
  );
}
